import { Organisation } from "../models/organisation";
import axiosConfig from "./axiosConfig";

export interface RelatedOrganisationListResponse {
  organisations: Organisation[];
}

const getRelatedOrganisationList = async (
  authToken: string,
  orgId: string,
  userOrgId?: string
): Promise<RelatedOrganisationListResponse> => {
  const { data } = await axiosConfig.get(
    `/organisation/${orgId}/related_organisations${
      userOrgId ? `?userOrgId=${userOrgId}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getRelatedOrganisationList;
